module.exports = "../dist/frontend/icons/ui/globe.svg?c3b869f2f0f8d53980a31be5d5cdf5dd";